module.exports = __webpack_public_path__ + "img/dashboard-orange.b2badb60.svg";